import { createQueryKeys } from '@lukemorales/query-key-factory';
import { fetchUserCartCount } from '@/app/(pages)/exhibition/api';
import { clientFetcher } from '../utils/fetcher/client-fetcher';
import { QueryKeys } from './query-keys';

export const journeyQueryKeys = createQueryKeys(QueryKeys.journey, {
  cartCount: () => ({
    queryKey: [''],
    queryFn: () => fetchUserCartCount(clientFetcher)(),
  }),
});
